module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-container conteudo-loading"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "subtitulo animated"
  })]), _c('div', {
    staticClass: "texto"
  }, [_c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated three-quarter"
  }), _c('div', {
    staticClass: "paragraph animated middle"
  })]), _c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated three-quarter"
  }), _c('div', {
    staticClass: "paragraph animated middle"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e256d78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/Loading.vue
// module id = 505
// module chunks = 0